import { FormExpand } from "@wingspanhq/wingspan-api-sdk";
import { formsApi } from "@api";
import { queriesForms } from "@query";
import { useWSQueries } from "../../helpers";

const EXPAND = [FormExpand.BLOCKED_BY_IDS];

/**
 * Fetches each form instance's enriched status (blockedByIds/title) — one
 * GET /compliance/forms/:formId?expand=BlockedByIds per id, fanned out
 * client-side — instead of the pair-scoped /checklist read.
 */
export const useQueryEmployeeTaxFormsInstanceStatuses = (formIds: string[]) =>
  useWSQueries({
    queries: formIds.map(formId => ({
      queryKey: queriesForms.getForm.getQueryKey({ formId, expand: EXPAND }),
      queryFn: () => formsApi.getForm({ formId, expand: EXPAND }),
      // Status can change out-of-band (a submit on another form, a payer
      // reset) — same convention as useQueryEmployeeTaxFormsChecklist.
      refetchOnMount: "always" as const,
      staleTime: 0
    }))
  });
